import React from 'react';

const PageContext = React.createContext({} as any);

export const PageProvider = (props: any) => {
  return <PageContext.Provider value={props}>{props.children}</PageContext.Provider>;
};
export default PageContext;
